import { useRef, useState } from 'react'
import classnames from 'classnames'
import NextArrowTransparent from '../svg/next-arrow-transparent'
import BackArrowTransparent from '../svg/back-arrow-transparent'
import SlideshowModal from '../slideshow-modal'
import Image from '../image'

export default function DesktopGallery({ initialIndex = 0, images, onReportClick, isDealer }) {
  const activeCarouselItemRef = useRef()
  const [index, setIndex] = useState(initialIndex)
  const [slideshow, setSlideshow] = useState({ open: false, photoIndex: 0 })

  const changeIndex = (newIndex) => {
    activeCarouselItemRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })

    setIndex(newIndex)
  }

  const toggleSlideshow = (value, index) => setSlideshow({ open: value, index })

  const handleImageSwitch = (newIndex) => {
    if (images.length === newIndex || newIndex === -1) return
    else changeIndex(newIndex)
  }

  const handleCarouselClick = (newIndex) => () => {
    if (newIndex === index) toggleSlideshow(true, index)
    else changeIndex(newIndex)
  }

  return (
    <>
      <div>
        <div className='wrapper flex flexDirectionColumn'>
          <div className='mainImgWrapper'>
            <div className='mainImageNavWrapper'>
              <button
                className={classnames('backArrow', { disabled: index === 0 })}
                onClick={() => handleImageSwitch(index - 1)}
                disabled={index === 0}
              >
                <BackArrowTransparent />
              </button>

              {images.map((entry, i) => (
                <div className={classnames({ active: index === i })} key={entry.url + i}>
                  <Image
                    src={entry.url}
                    width='1440'
                    height='810'
                    onClick={() => toggleSlideshow(true, index)}
                    alt='car'
                    fullRes
                  />
                  <button
                    className='flatBtn report'
                    onClick={() => onReportClick(images[index]?.photoType, images[index]?.id)}
                  >
                    Report
                  </button>
                </div>
              ))}

              <button
                className={classnames('nextArrow', { disabled: index + 1 === images.length })}
                onClick={() => handleImageSwitch(index + 1)}
                disabled={index + 1 === images.length}
              >
                <NextArrowTransparent />
              </button>
            </div>
          </div>

          {isDealer && (
            <div style={{ color: 'var(--alert-color)', fontSize: '1.75rem' }}>
              * This dealer vehicle may contain stock images
            </div>
          )}

          <div className='carousel flex '>
            <button
              className={classnames('arrow previous flex justifyCenter alignCenter', {
                disabled: index === 0,
              })}
              onClick={() => handleImageSwitch(index - 1)}
              disabled={index === 0}
            >
              <BackArrowTransparent width='22.8' height='22.8' fill='#A5A8B9' />
            </button>

            <div className='carCarousel'>
              {images.map((entry, i) => (
                <button
                  ref={(ref) => (i === index ? (activeCarouselItemRef.current = ref) : null)}
                  className={classnames('imgItem', { active: i === index })}
                  onClick={handleCarouselClick(i)}
                  key={i}
                >
                  <Image src={entry.url} alt='car' width='100' height='100' />
                </button>
              ))}
            </div>

            <button
              className={classnames('arrow next flex justifyCenter alignCenter', {
                disabled: index + 1 === images.length,
              })}
              onClick={() => handleImageSwitch(index + 1)}
              disabled={index + 1 === images.length}
            >
              <NextArrowTransparent width='22.8' height='22.8' fill='#A5A8B9' />
            </button>
          </div>
        </div>

        {slideshow.open && (
          <SlideshowModal
            initialIndex={index}
            images={images}
            onClose={() => toggleSlideshow(false, 0)}
          />
        )}
      </div>

      <style jsx>{`
        .arrow {
          width: 3.8rem;
          height: 8.7rem;
          border-radius: 1rem;
          background: #1a1e21;
          cursor: pointer;

          &.previous {
            margin: 0 0.9rem 0 0;
          }

          &.next {
            margin: 0 0 0 0.9rem;
          }

          &.disabled {
            cursor: not-allowed;
            opacity: 0.3;
          }
        }

        .backArrow,
        .nextArrow {
          position: absolute;
          cursor: pointer;
          z-index: 1;
          top: 50%;
          transform: translate(0, -50%);
          background: transparent;

          &.disabled {
            cursor: not-allowed;
            opacity: 0.3;
          }
        }

        .nextArrow {
          right: 0.9rem;
        }

        .backArrow {
          left: 0.9rem;
        }

        .report {
          background: rgba(0, 0, 0, 0.47) !important;
          padding: 0.6rem;
          border-radius: 1rem;
          position: absolute;
          bottom: 2.2rem;
          right: 2rem;
          color: #fff;
          text-decoration: underline;
          font-size: 1.8rem;
        }

        .carCarousel {
          overflow: auto;
          width: 100%;
          height: 100%;
          white-space: nowrap;
          user-select: none;
        }

        .carCarousel span {
          display: inline-block;
        }

        .imgItem {
          position: relative;
          height: 100%;
          margin: 0 0.45rem;
          padding: 0.4rem 0;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          outline: none;
          background: transparent;

          :global(img) {
            object-fit: cover;
            height: 8.7rem;
            width: 9.7rem;
            border-radius: 1rem;
          }

          &.active,
          :focus {
            :global(img) {
              box-sizing: content-box;
              box-shadow: 0 0 0 0.2rem #0e77ef, 0 0 0 0.3rem #0e77ef70, 0 0 0 0.4rem #0e77ef38;
            }
          }
        }

        .carousel {
          position: relative;
          margin: 1.2rem 0 0;
          height: calc(8.7rem + 0.8rem);
          align-items: center;
        }

        .content {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
        }

        .wrapper {
          display: flex;
          overflow: hidden;
        }

        .mainImgWrapper {
          width: 100%;
          margin: 0 2.3rem 0 0;
        }

        .mainImageNavWrapper {
          position: relative;
          padding: calc(4.6 / 8.2 * 100%) 0 0 0;
          overflow: hidden;
          border-radius: 1rem;
          user-select: none;

          div {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            opacity: 0;
            cursor: zoom-in;
            transition: opacity 0.1s;

            :global(img) {
              object-fit: cover;
              width: 100%;
              height: 100%;
            }

            &.active {
              opacity: 1;
              transition: opacity 0.1s;
            }
          }
        }

        @media (min-width: 1024px) {
          .carCarousel {
            -ms-overflow-style: none;
            scrollbar-width: none;

            ::-webkit-scrollbar {
              display: none;
            }
          }
        }
      `}</style>
    </>
  )
}
